export const DEVICE_INFO_NO_STREAM_ENDPOINT = "/MDM/Fully/DeviceInfo/NoStream";

const ENDPOINT_TO_ACTION_MAP = {
  "/MDM/Fully/DeviceInfo": "device_info",
  [DEVICE_INFO_NO_STREAM_ENDPOINT]: "device_info",
  "/MDM/Fully/GetScreenshot": "get_screenshot",
  "/Trigger-Screen-Shot": "field_screenshot",
  "/MDM/Field/FetchDeviceConfigLog": "fetch_device_config_log",
  "/MDM/Field/FetchBrandingConfigLog": "fetch_branding_config_log",
  "/MDM/Field/FetchScanAndGoConfigLog": "fetch_scan_and_go_config_log",
  "/MDM/Field/FetchLocationLog": "fetch_location_log",
  "/MDM/Field/MultiFetchLocationLog": "fetch_location_log",
  "/MDM/Field/FetchNcrStatus": "fetch_ncr_status",
  "/MDM/Field/UpdateDataBase": "update_database",
  "/MDM/Field/UpdateDataBaseNoTimestamp": "update_database_no_timestamp",
  "/MDM/Field/ChangeNcrServer": "change_ncr_server",
  "/MDM/Field/ClearAllAndUpdate": "clear_all_and_update",
  "/MDM/ScanAndGo/AllowedReleaseDeviceFromCradle": "allowed_release_device_from_cradle",
  "/MDM/ScanAndGo/ReleaseDeviceFromCradle": "release_device_from_cradle",
  "/MDM/ScanAndGo/ReleaseWallFromCradle": "release_wall_from_cradle",
  "/MDM/Fully/SetStringSetting": "set_string_setting",
  "/MDM/Fully/SetBooleanSetting": "set_boolean_setting",
  "/MDM/Fully/SetIntegerSetting": "set_integer_setting",
  "/MDM/Fully/LoadApkFile": "load_apk_file",
  "/MDM/Fully/K10LenovoShutdown": "k10_lenovo_shutdown",
  "/MDM/Fully/K10LenovoSetMobileData": "k10_lenovo_set_mobile_data",
  "/MDM/Fully/K10LenovoSetDataRoaming": "k10_lenovo_set_data_roaming",
  "/MDM/Fully/K10LenovoSetDataAlwaysOn": "k10_lenovo_set_data_always_on",
  "/MDM/Fully/K10LenovoAvoidBadData": "k10_lenovo_avoid_bad_data",
  "/MDM/Fully/K10LenovoSetSystemuiWifiSwitchAsk": "k10_lenovo_set_systemui_wifi_switch_ask",
  "/MDM/Fully/K10LenovoSetLenovoWifiSwitchAsk": "k10_lenovo_set_lenovo_wifi_switch_ask",
  "/MDM/Fully/K10LenovoSetWakeSchedule": "k10_lenovo_set_wake_schedule",
  "/MDM/Fully/K10LenovoSetShutdownSchedule": "k10_lenovo_set_shutdown_schedule",
};

export const LOAD_APK_FILE_ENDPOINT = "/MDM/Fully/LoadApkFile";
export const K10_LENOVO_SHUTDOWN_ENDPOINT = "/MDM/Fully/K10LenovoShutdown";

export const K10_LENOVO_DEVICE_MODEL = "Lenovo TB-X6C6X";

export const K10_CSDK_TOGGLE_ENDPOINTS = new Set([
  "/MDM/Fully/K10LenovoSetMobileData",
  "/MDM/Fully/K10LenovoSetDataRoaming",
  "/MDM/Fully/K10LenovoSetDataAlwaysOn",
  "/MDM/Fully/K10LenovoAvoidBadData",
  "/MDM/Fully/K10LenovoSetSystemuiWifiSwitchAsk",
  "/MDM/Fully/K10LenovoSetLenovoWifiSwitchAsk",
]);

export const K10_CSDK_SCHEDULE_ENDPOINTS = new Set([
  "/MDM/Fully/K10LenovoSetWakeSchedule",
  "/MDM/Fully/K10LenovoSetShutdownSchedule",
]);

export const K10_CSDK_ENDPOINTS = new Set([
  ...K10_CSDK_TOGGLE_ENDPOINTS,
  ...K10_CSDK_SCHEDULE_ENDPOINTS,
]);

export const K10_COMMAND_ENDPOINTS = new Set([
  K10_LENOVO_SHUTDOWN_ENDPOINT,
  ...K10_CSDK_ENDPOINTS,
]);

export const k10CommandOptions = [
  { label: "Mobile Data", value: "/MDM/Fully/K10LenovoSetMobileData" },
  { label: "Data Roaming", value: "/MDM/Fully/K10LenovoSetDataRoaming" },
  { label: "Data Always-On", value: "/MDM/Fully/K10LenovoSetDataAlwaysOn" },
  { label: "Avoid Bad Wi-Fi", value: "/MDM/Fully/K10LenovoAvoidBadData" },
  { label: "SystemUI Wi-Fi Switch Ask", value: "/MDM/Fully/K10LenovoSetSystemuiWifiSwitchAsk" },
  { label: "Lenovo Wi-Fi Switch Ask", value: "/MDM/Fully/K10LenovoSetLenovoWifiSwitchAsk" },
  { label: "Wake Schedule", value: "/MDM/Fully/K10LenovoSetWakeSchedule" },
  { label: "Shutdown Schedule", value: "/MDM/Fully/K10LenovoSetShutdownSchedule" },
  { label: "Shutdown", value: K10_LENOVO_SHUTDOWN_ENDPOINT },
];

export const buildAllowedK10Options = (normalizedOptions = []) => {
  const byValue = new Map(
    (Array.isArray(normalizedOptions) ? normalizedOptions : []).map((option) => [
      option.value,
      option,
    ])
  );
  return k10CommandOptions
    .map((option) => byValue.get(option.value))
    .filter(Boolean);
};

export const collapseK10Commands = (options, allowedK10 = []) => {
  const normalized = Array.isArray(options) ? options : [];
  const allowed = Array.isArray(allowedK10)
    ? allowedK10.filter((option) => K10_COMMAND_ENDPOINTS.has(option.value))
    : [];

  if (!allowed.length) {
    return normalized.filter((option) => !K10_COMMAND_ENDPOINTS.has(option.value));
  }

  const without = normalized.filter((option) => !K10_COMMAND_ENDPOINTS.has(option.value));
  const groupKey = allowed[0].value;
  return [...without, { label: "K10 Commands", value: groupKey }];
};

export const FULLY_SET_STRING_ENDPOINT = "/MDM/Fully/SetStringSetting";
export const FULLY_SET_BOOLEAN_ENDPOINT = "/MDM/Fully/SetBooleanSetting";
export const FULLY_SET_INTEGER_ENDPOINT = "/MDM/Fully/SetIntegerSetting";

export const FULLY_SETTINGS_ENDPOINTS = new Set([
  FULLY_SET_STRING_ENDPOINT,
  FULLY_SET_BOOLEAN_ENDPOINT,
  FULLY_SET_INTEGER_ENDPOINT,
]);

export const fullySettingsOptions = [
  { label: "Set String Setting", value: FULLY_SET_STRING_ENDPOINT },
  { label: "Set Boolean Setting", value: FULLY_SET_BOOLEAN_ENDPOINT },
  { label: "Set Integer Setting", value: FULLY_SET_INTEGER_ENDPOINT },
];

export const collapseFullySettingsCommands = (options, allowedFullySettings = []) => {
  const normalized = Array.isArray(options) ? options : [];
  const allowed = Array.isArray(allowedFullySettings)
    ? allowedFullySettings.filter((option) => FULLY_SETTINGS_ENDPOINTS.has(option.value))
    : [];

  if (!allowed.length) {
    return normalized.filter((option) => !FULLY_SETTINGS_ENDPOINTS.has(option.value));
  }

  const without = normalized.filter((option) => !FULLY_SETTINGS_ENDPOINTS.has(option.value));
  const groupKey = allowed[0].value;
  return [...without, { label: "Fully Settings", value: groupKey }];
};

export const normalizeCommandOptions = (rawOptions) => {
  if (Array.isArray(rawOptions)) {
    return rawOptions
      .map((option) => {
        if (typeof option === "string") {
          return { label: option, value: option };
        }
        if (!option || typeof option !== "object") return null;
        return {
          label: option.label || option.name || option.value || "Unknown",
          value: option.value || option.endpoint || "",
        };
      })
      .filter(Boolean)
      .filter((option) => String(option.value || "").trim());
  }
  if (rawOptions && typeof rawOptions === "object") {
    return Object.entries(rawOptions)
      .map(([label, value]) => ({
        label,
        value: String(value || ""),
      }))
      .filter((option) => String(option.value || "").trim());
  }
  return [];
};

export const normalizeStringOptions = (rawOptions) => {
  if (!Array.isArray(rawOptions)) return [];
  return rawOptions.map((value) => String(value || "").trim()).filter(Boolean);
};

export const getTextPayloadKeyForEndpoint = (endpoint, options) =>
  options.find((option) => option.value === endpoint)?.payloadKey ?? null;

export const normalizeActionKey = (action) =>
  String(action || "")
    .trim()
    .toLowerCase()
    .replace(/[^\w]+/g, "_")
    .replace(/^_+|_+$/g, "");

export const getActionKeyForEndpoint = (endpoint) => {
  if (ENDPOINT_TO_ACTION_MAP[endpoint]) return ENDPOINT_TO_ACTION_MAP[endpoint];
  const endpointTail = String(endpoint || "").split("/").filter(Boolean).pop() || "";
  return normalizeActionKey(endpointTail) || "unknown_action";
};

export const parseSseEventBlock = (rawBlock) => {
  if (!rawBlock || !rawBlock.trim()) return null;

  let eventName = "message";
  const dataLines = [];
  const lines = rawBlock.split("\n");

  lines.forEach((line) => {
    if (!line || line.startsWith(":")) return;
    if (line.startsWith("event:")) {
      eventName = line.slice(6).trim();
    }
    if (line.startsWith("data:")) {
      dataLines.push(line.slice(5).trim());
    }
  });

  if (!dataLines.length) return null;
  const rawData = dataLines.join("\n");

  try {
    return { event: eventName, data: JSON.parse(rawData) };
  } catch {
    return { event: eventName, data: rawData };
  }
};

export const normalizeDeviceResult = (result) => {
  if (!result || typeof result !== "object") {
    return { deviceId: "", normalizedResult: result };
  }

  const directDeviceId =
    result?.device_id ||
    result?.deviceId ||
    result?.device?.device_id ||
    result?.device?.deviceId ||
    result?.device?.id;

  if (directDeviceId) {
    return { deviceId: String(directDeviceId), normalizedResult: result };
  }

  const entries = Object.entries(result);
  if (entries.length === 1 && typeof entries[0][1] === "object" && entries[0][1] !== null) {
    const [singleKey, singleValue] = entries[0];
    return {
      deviceId: String(singleKey),
      normalizedResult: {
        ...singleValue,
        device_id: String(singleKey),
        device_info: singleValue?.device_info || singleValue,
        status: singleValue?.status || "ok",
      },
    };
  }

  return { deviceId: "", normalizedResult: result };
};

export const isSuccessfulCommandResult = (normalizedResult) => {
  if (!normalizedResult || typeof normalizedResult !== "object") return false;

  const status = String(normalizedResult?.status || normalizedResult?.result || "")
    .trim()
    .toLowerCase();

  if (status) {
    return ["ok", "success", "completed"].includes(status);
  }

  if (normalizedResult?.success === false) return false;
  if (normalizedResult?.error) return false;
  return true;
};
